import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { SkeletonDisplayText } from '@shopify/polaris'
import get from 'lodash/get'
import map from 'lodash/map'

import { fetchProductsByCollection } from 'controllers/shopifyApp'
import ProductRow from './ProductRow'
import Text from 'components/common/Text'
import { CustomScrollBar } from 'components/styles'

const Wrapper = styled.div`
  min-height: 10em;
  max-height: 35em;
  display: flex;
  flex-direction: column;
`
const ProductsListContainer = styled.div`
  height: 100%;
  margin-top: 1em;
  overflow-y: auto;
  ${CustomScrollBar}
  & .Polaris-SkeletonDisplayText__DisplayText {
    max-width: none;
    width: 100%;
    margin-bottom: 0.1em;
  }

`

class CollectionProductsList extends Component {

  constructor (props) {
    super(props)
    console.log('CollectionProductsList constructor', props)
    this.state = {
      loading: true,
      products: []
    }
  }

  componentWillMount () {
    const { collection, dispatch } = this.props
    const products = collection.products
    if (!products) {
      dispatch(fetchProductsByCollection(collection.id))
    } else {
      this.setState({
        products: products,
        loading: false,
      })
    }
  }

  componentWillReceiveProps (nextProps) {
    console.log('CWRP, products', nextProps.collection)
    const { collection } = nextProps
    const products = collection.products
    if (products) {
      this.setState({
        products: products,
        loading: false
      })
    }
  }

  renderProduct = (p, i) => {
    const { pId0, pId1 } = this.props
    const isChecked = p.id === pId0 || p.id === pId1
    console.log('p.id', p.id, 'pId0', pId0, 'pId1', pId1, 'isChecked', isChecked)
    return (
      <ProductRow
        key={i}
        productId={p.id}
        image={get(p, ['image', 'src'], get(p, ['images', 0, 'src']))}
        title={p.title}
        isChecked={isChecked}
        onSelect={this.props.onSelect}
        onRemove={this.props.onRemove}
      />
    )
  }

  renderProductsList () {
    const { loading, products } = this.state
    console.log('render products list, products', products)
    if (loading) {
      return (
        <ProductsListContainer>
          <SkeletonDisplayText />
          <SkeletonDisplayText />
          <SkeletonDisplayText />
        </ProductsListContainer>
      )
    } else {
      return (
        <ProductsListContainer>
          {map(products, this.renderProduct)}
        </ProductsListContainer>
      )
    }
  }

  render () {
    return (
      <Wrapper>
        <Text>Select up to 2 products to display</Text>
        {this.renderProductsList()}
      </Wrapper>
    )
  }
}



CollectionProductsList.propTypes = {
  collection: PropTypes.object.isRequired,
  pId0: PropTypes.number,
  pId1: PropTypes.number,
  onSelect: PropTypes.func,
  onRemove: PropTypes.func
}


export default connect()(CollectionProductsList)



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/addCollection/CollectionProductsList.js